type Props = {
    children: any;
}

export const HeadingOne = ({ children }: Props) => {
  return (
      <h1 className="font-semibold text-3xl lg:text-5xl">{children}</h1>
  )
}
export const HeadingTwo = ({ children }: Props) => {
  return (
      <h2 className="text-xl">{children}</h2>
  )
}
export const HeadingThree = ({ children }: Props) => {
  return (
      <h1>{children}</h1>
  )
}

const Default = ({ children }: Props) => {
  return (
    <p>{children}</p>
  )
}

export default Default
